import {Injectable} from "@angular/core";
import {Observable, Subject} from "rxjs";

@Injectable()
export class ProjectService{
    provinceIcon = new Subject<any>();
    cityIcon = new Subject<any>();

    public ProvinceLogoSet(saveData) {
        this.provinceIcon.next({provinceIcon: saveData});
    }

    public ProvinceLogoGet(): Observable<any> {
        return this.provinceIcon.asObservable();
    }

    public CityLogoSet(saveData) {
        this.cityIcon.next({cityIcon: saveData});
    }

    public CityLogoGet(): Observable<any> {
        return this.cityIcon.asObservable();
    }
}
